import * as React from 'react';
import cx from 'classnames';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import ApproversTableRows from './ApproversTableRows';
import Loader from 'components/Loader/Loader';

const styles = require('./styles.pcss');

type Props = {
  isLoading: boolean;
  approversList: any;
};

class Approvers extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  renderEmptyApprovers = () => {
    const { approversList = [] } = this.props || {};
    if (!approversList?.length) {
      return <div className={styles.emptyData}>No Approvers</div>;
    }

    return null;
  };

  render() {
    const { isLoading, approversList = [] } = this.props || {};
    return (
      <Paper
        className={
          isLoading
            ? cx(styles.paper, styles.approversPaper, styles.loading)
            : cx(styles.paper, styles.approversPaper)
        }
      >
        <div className={styles.policyRules}>
          <h2>Approvers</h2>
          <div>
            <Loader visible={isLoading} />
          </div>
          <Table>
            <TableBody>
              {approversList.map((user: any) => (
                <ApproversTableRows user={user} />
              ))}
            </TableBody>
          </Table>
          {this.renderEmptyApprovers()}
        </div>
      </Paper>
    );
  }
}

export default Approvers;
